import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {
  CorporateIncomeTaxConnectedCorporationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/income-tax/corporate/common/corporate-income-tax-connected-corporation.options';

@Component({
  selector: 'app-salary-dividend-corporate-tax-connected-corporation-form',
  templateUrl: './salary-dividend-corporate-tax-connected-corporation-form.component.html',
  styleUrls: ['./salary-dividend-corporate-tax-connected-corporation-form.component.scss'],
  standalone: false,
})
export class SalaryDividendCorporateTaxConnectedCorporationFormComponent {

  @Input()
  connectedCorporationForm: AdvancedFormGroup<CorporateIncomeTaxConnectedCorporationOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  refresh() {
  }
}
